<template>
    <div :id="id"
         :key="'key-' + id"
         @click.passive="$emit('click')">
        <template v-if="mode==='expand'">
            <v-text-field
                :disabled="disabled"
                :hint="hint"
                :label="label"
                :placeholder="placeholder"
                :prepend-icon="expand ? 'mdi-check-circle' : 'mdi-palette'"
                :value="inner_value_colorname"
                dense
                hide-details="auto"
                outlined
                readonly
                @blur="focused=false"
                @click="expand=true"
                @focus="expand=true;focused=true"
                @click:prepend="expand=!expand;"><!--append-icon="mdi-circle"-->
                <template v-slot:prepend>
                    <v-icon :color="expand || focused ? 'primary' : ''"
                            :disabled="disabled"
                            @click="expand=!expand;">
                        {{ expand ? 'mdi-check-circle' : 'mdi-palette' }}
                    </v-icon>
                </template>
                <template v-slot:append>
                    <div
                        :style="textFieldIconContainerStyle"
                        class="colorpicker-color-preview-container">
                        <div :style="textFieldIconStyle"
                             class="colorpicker-color-preview" />
                    </div>
                </template>
            </v-text-field>
            <v-expand-transition v-if="!disabled">
                <v-card
                    v-show="expand"
                    :style="{zIndex: 2, float: alignRight ? 'right' : '', margin: 'auto', maxWidth: '300px'}"
                    width="max(250px, min(100%,300px))"
                    @focus="expand=true">
                    <v-color-picker
                        v-model="inner_value_color"
                        :style="{paddingTop: '8px', paddingBottom: '8px', marginTop: '0 !important', marginBottom: '0'}"
                        class="ma-2"
                        v-bind="commonPropsColorpicker"
                    ></v-color-picker>
                </v-card>
            </v-expand-transition>
        </template>
        <template v-else>
            <v-menu
                ref="menu"
                v-model="menuOpen"
                :attach="$refs.popper"
                :close-on-content-click="false"
                :disabled="disabled"
                content-class="menu-rounded menu-padding-top-left-right"
                transition="popper-scale"
                max-width="316px"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        ref="textField"
                        class="colorpicker-color-text-input"
                        :disabled="disabled"
                        :hint="hint"
                        :label="label"
                        :placeholder="placeholder"
                        :prepend-icon="menuOpen ? 'mdi-check-circle' : 'mdi-circle'"
                        :value="inner_value_colorname"
                        dense
                        hide-details="auto"
                        outlined
                        readonly
                        v-bind="attrs"
                        @blur="focused=false"
                        @focus="focused=true"
                        v-on="on"
                        @click:prepend="menuOpen = !menuOpen">
                        <template v-slot:prepend>
                            <v-icon :color="menuOpen || focused ? 'primary' : ''"
                                    :disabled="disabled"
                                    @click="menuOpen = !menuOpen">
                                {{ menuOpen ? 'mdi-check-circle' : 'mdi-palette' }}
                            </v-icon>
                        </template>
                        <template v-slot:append>
                            <div
                                :style="textFieldIconContainerStyle"
                                class="colorpicker-color-preview-container">
                                <div :style="textFieldIconStyle"
                                     class="colorpicker-color-preview" />
                            </div>
                        </template>
                    </v-text-field>


                    <portal selector="#app">
                        <div
                            ref="popper"
                            class="popper-menu-anchor"
                            :class="{'popper-menu-hide-under-navbar': !popupUsedInModal}"
                        >
                        </div>
                    </portal>
                </template>

                <v-color-picker
                    v-if="menuShown"
                    v-model="inner_value_color"
                    v-bind="commonPropsColorpicker"
                    :swatches-max-height="260"
                    :dot-size="20"
                />

            </v-menu>
        </template>
    </div>
</template>

<script>
import { colorHexToName } from '../../../utils/colors'
import popperPositionedVuetifyMenuMixin from '../../mixins/popperPositionedVuetifyMenuMixin';
import { Portal } from '@linusborg/vue-simple-portal';

export default {
    components: { Portal },
    mixins: [popperPositionedVuetifyMenuMixin],
    props: {
        label: String,
        value: {
            type: String,
            default: '#000000'
        },
        disabled: Boolean,
        placeholder: String,
        id: String,
        alignRight: Boolean,
        mode: String,
        pickerFamily: String,
        hint: String,
        popupUsedInModal: {
            type: Boolean,
            default: true
        }
    },
    data: function() {
        return {
            menuOpen: false,
            expand: false,
            focused: false,
            colorRegex: /^(?<hex>#[0-9a-f]{6})ff$/gi
        }
    },
    computed: {
        inner_value_color: {
            get() {
                return this.value
            },
            set(val) {
                if (val.toLowerCase() !== this.value.toLowerCase()) {
                    this.$emit('input', val)
                }
            }
        },
        textFieldIconStyle() {
            return {
                'background-color': this.value
            }
        },
        textFieldIconContainerStyle() {
            return {
                'outline-color': this.value
            }
        },
        inner_value_colorname() {
            return colorHexToName(this.value);
        },
        commonPropsColorpicker() {
            return {
                mode: 'hexa',
                showSwatches: true,
                swatchesMaxHeight: 284,
                canvasHeight: 128
            }
        },
        popperOffset() {
            return [33, 0];
        }
    },
    methods: {
        getReferenceEl() {
            return this.$refs.textField.$el;
        },
        getPopperEl() {
            return this.$refs.popper;
        },
        getVMenuEl() {
            return this.$refs.menu.$el;
        }
    },
    watch: {
        id() {
            this.menuOpen = false
            this.expand = false
        }
    }
}
</script>
